import { XS } from "constants/sizes";
import Colors from "styles/colors";
import { useMemo } from "react";
import CheckboxSVG from "../../checkbox-icon";
import { componentStyles } from "./product-card-use-cases.scss";
import SelectableTagsGrid from "../../../selectable-tags-grid/selectable-tags-grid";
import ProductSignUp from "../../../product-sign-up/product-sign-up";

const ProductCardUseCases = ({ useCases, productColor, isUseCasesReadonly, productType }) => {
  const buttonConfig = useMemo(
    () => ({
      useCtaIcon: true,
      buttonSize: XS,
      buttonColor: productColor,
      productIdToUse: productType,
      skipUpdateCluster: true,
      extraData: { selectedProduct: productType }
    }),
    [productColor, productType]
  );

  const gridSelectableTags = useMemo(
    () => useCases?.map(({ useCase, ...rest }) => ({ tagText: useCase, ...rest })),
    [useCases]
  );

  return (
    <div className="product-card-use-cases" style={{ "--color": Colors[productColor] }}>
      {isUseCasesReadonly ? (
        <div className="readonly-use-cases-wrapper">
          {useCases?.map(({ useCase }) => (
            <div className="readonly-use-case">
              <CheckboxSVG />
              {useCase}
            </div>
          ))}
        </div>
      ) : (
        <SelectableTagsGrid
          buttonTopMargin="0"
          disableAnimation
          buttonConfig={buttonConfig}
          gridSelectableTags={gridSelectableTags}
        />
      )}

      {isUseCasesReadonly && (
        <ProductSignUp useCtaIcon buttonSize={XS} buttonColor={productColor} productType={productType} />
      )}
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default ProductCardUseCases;
